import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/StudentApplication/List",
    method: "get",
    params
  });
}

export function recover(data) {
  return request({
    url: "/StudentApplication/Recover",
    method: "post",
    data
  });
}

export function getNewStudent(params) {
  return request({
    url: "/StudentApplication/NewStudent",
    method: "get",
    params
  });
}

export function getOldStudent(params) {
  return request({
    url: "/StudentApplication/OldStudent",
    method: "get",
    params
  });
}